import React, { useEffect } from 'react'
import MediaWithShimmer from './MediaWithShimmer'
import { useLanguage } from '../contexts/LanguageContext'
import { Link } from 'react-router-dom'

import img1 from '../img/coctail/Изображение WhatsApp 2025-11-21 в 14.44.51_ccf7913a.jpg'
import img2 from '../img/coctail/Изображение WhatsApp 2025-11-21 в 14.44.52_02072f8a.jpg'
import img3 from '../img/coctail/Изображение WhatsApp 2025-11-21 в 14.44.53_9c18fdff.jpg'
import img4 from '../img/coctail/Изображение WhatsApp 2025-11-21 в 14.44.53_22fa76d6.jpg'
import img5 from '../img/coctail/Изображение WhatsApp 2025-11-21 в 14.44.53_a42a264a.jpg'
import img6 from '../img/coctail/Изображение WhatsApp 2025-11-21 в 14.44.54_2f99bf81.jpg'
import coctail1 from '../imgs/coctail1.jpg'
import coctail2 from '../imgs/coctail2.jpg'
import coctail3 from '../imgs/coctail3.jpg'
import coctail4 from '../imgs/coctail4.jpg'
import romantic1 from '../imgs/romantic1.jpg'
import romantic2 from '../imgs/romantic2.jpg'
import romantic3 from '../imgs/romantic3.jpg'
import romantic6 from '../imgs/romantic6.jpg'
import romantic7 from '../imgs/romantic7.jpg'
import romantic8 from '../imgs/romantic8.jpg'
import romantic9 from '../imgs/romantic9.jpg'
import romantic10 from '../imgs/romantic10.jpg'
import romantic11 from '../imgs/romantic11.jpg'
import romantic12 from '../imgs/romantic12.jpg'
import romantic13 from '../imgs/romantic13.jpg'
import romantic14 from '../imgs/romantic14.jpg'
import romantic15 from '../imgs/romantic15.jpg'
import romantic16 from '../imgs/romantic16.jpg'
import white13 from '../imgs/white13.jpg'
import white14 from '../imgs/white14.jpg'
import white15 from '../imgs/white15.jpg'
import white16 from '../imgs/white16.jpg'
import white17 from '../imgs/white17.jpg'
import white18 from '../imgs/white18.jpg'
import white19 from '../imgs/white19.jpg'

const CoctailDressCollection = () => {
  const { language } = useLanguage()
  
  useEffect(() => {
    if (typeof window === 'undefined') return

    const el = document.getElementById('cocktail')
    if (!el) return

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            window.dispatchEvent(
              new CustomEvent('section:change', {
                detail: { id: 'cocktail' }
              })
            )
          }
        })
      },
      {
        root: null,
        threshold: 0.25
      }
    )

    observer.observe(el)

    return () => observer.disconnect()
  }, [])

  return (
    <section id="cocktail" className="bg-white px-4">
      <div className="max-w-7xl mx-auto">
        <div className="mb-5 text-center">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-light tracking-[0.15em] uppercase playfair mb-5">
            {language === 'ru' ? 'Коктейльные платья' : 'Cocktail dresses'}
          </h2>
          <p className="text-sm md:text-base text-gray-600 montserrat max-w-3xl mx-auto">
            {language === 'ru'
              ? 'Романтические коктейльные платья для современных леди — подчеркивают женственность, лёгкость и изысканную элегантность для любого особого случая.'
              : 'Romantic style cocktail dresses for ladies — highlighting femininity, lightness and refined elegance for any special occasion.'}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {[
            img1,
            img2,
            img3,
            img4,
            img5,
            img6,
            coctail1,
            coctail2,
            coctail4,
            coctail3,
            romantic1,
            romantic2,
            romantic3,
            romantic6,
            romantic7,
            romantic8,
            romantic9,
            romantic10,
            romantic11,
            romantic12,
            romantic13,
            romantic14,
            romantic15,
            romantic16,
            white13,
            white14,
            white15
          ].map((src, index) => (
            <Link to="/shop" key={index} className="group cursor-pointer block">
              <div className="relative overflow-hidden rounded-3xl border border-[#CEA15F]/40 shadow-[0_0_40px_rgba(206,161,95,0.25)]">
                <img
                  src={src}
                  alt={`Cocktail dress ${index + 1}`}
                  className="w-full h-[720px] md:h-[580px] object-cover object-center transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/15 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  )
}

export default CoctailDressCollection
